export function noop() {}

export default noop
